import { useTranslation } from "react-i18next";
import Checkbox from "@/components/atomic/Checkbox";
import { ChatAttributeFilter, createChatCategoricalAttributeFilter } from "@/components/ui/chat/chatFilterUtils";
import { Attribute, AttributeType } from "@/models/attribute";

interface CategoricalAttributeFilterProps {
  attribute: Attribute;
  currentFilter: ChatAttributeFilter | undefined;
  onFilterChange: (attributeName: string, filter: ChatAttributeFilter | null) => void;
}

export const CategoricalAttributeFilter: React.FC<CategoricalAttributeFilterProps> = ({
  attribute,
  currentFilter,
  onFilterChange,
}) => {
  const { t } = useTranslation("voiceek_ui");

  const selectedValues = (currentFilter?.filter.type === AttributeType.CATEGORICAL)
    ? currentFilter.filter.values
    : [];
  const isAllSelected = selectedValues.length === attribute.values?.length;

  const handleSelectAll = (checked: boolean) => {
    if (attribute.values) {
      if (checked && attribute.values.length > 0) {
        const chatFilter = createChatCategoricalAttributeFilter(attribute.values, attribute.values);
        onFilterChange(attribute.name, chatFilter);
      } else {
        onFilterChange(attribute.name, null);
      }
    }
  };

  const handleValueToggle = (value: string, checked: boolean) => {
    const newValues = checked
      ? [...selectedValues, value]
      : selectedValues.filter((v) => v !== value);

    if (newValues.length > 0) {
      const chatFilter = createChatCategoricalAttributeFilter(newValues, attribute.values);
      onFilterChange(attribute.name, chatFilter);
    } else {
      onFilterChange(attribute.name, null);
    }
  };

  return (
    <div className="flex flex-col gap-4 py-4">
      {/* 全て選択 */}
      <button className="flex items-center gap-2 hover:cursor-pointer" onClick={() => handleSelectAll(!isAllSelected)}>
        <Checkbox
          checked={isAllSelected}
          className="hover:cursor-pointer"
        />
        <span className="text-[14px] text-[#333333] text-left">{t("chat.filter.all")}</span>
      </button>

      {/* 個別の値 */}
      <div className="flex flex-wrap gap-x-[24px] gap-y-[18px]">
        {attribute.values?.map((value) => (
          <button
            key={value}
            className="flex items-center gap-2 hover:cursor-pointer"
            onClick={() => handleValueToggle(value, !selectedValues.includes(value))}
          >
            <Checkbox
              checked={selectedValues.includes(value)}
              className="hover:cursor-pointer"
            />
            <span className="text-[14px] text-[#333333] text-left">{value}</span>
          </button>
        ))}
      </div>

      {/* エラーメッセージ */}
      {currentFilter?.error && (
        <p className="text-[12px] text-red-500">
          {t(currentFilter.error)}
        </p>
      )}
    </div>
  );
};
